<template>
  <div class="activity-osten-sub">
    <div class="activity-osten-main">
    <header class="header">
      <div class="header__logo-wrap">
        <img class="header__logo" :src="cdnLogo" alt="" />
      </div>
      <div class="header__titles">
        <div class="header__line1">{{ $t('osten.home.title_line1') }}</div>
        <div class="header__line2">{{ $t('osten.home.title_line2') }}</div>
      </div>
    </header>

    <div class="switch">
      中文
      <van-switch
        style="margin: 0 12px;"
        size="24"
        v-model="checked"
        active-color="#1F57A7"
        inactive-color="#e8ecf2"
        @change="switchLanguage"
      />
      EN
    </div>

    <div class="sub-btns">
      <button
        v-for="(row, idx) in linkRows"
        :key="idx"
        type="button"
        class="sub-btn"
        @click="openMatch(row.url)"
      >
        {{ $t(row.i18nKey) }}
      </button>
    </div>
    </div>

    <section class="partners" aria-label="sponsors" v-if="false">
      <div class="partners__grid">
        <div
          v-for="(url, index) in sponsorUrls"
          :key="index"
          class="partners__item"
        >
          <img class="partners__logo" :src="url" alt="" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import { Switch } from 'vant'

Vue.use(Switch)

const OSTEN_CDN = 'https://images.snsports.cn'
const MATCH_H5 = 'https://www.snsports.cn/match-h5/index.html'
const MATCH_H5_LIVE_ZH = `${MATCH_H5}?lang=zh-CN&open_in_browser=true`

/** 各运动二级页：篮球/足球（女子在上），体操为日期选择 */
const SUB_LINKS = {
  gymnastics: [
    {
      url: `${MATCH_H5_LIVE_ZH}#/live-page/3667639`,
      i18nKey: 'osten.subSelect.gymnastics_apr14'
    },
    {
      url: `${MATCH_H5_LIVE_ZH}#/live-page/3667640`,
      i18nKey: 'osten.subSelect.gymnastics_apr17'
    }
  ],
  basketball: [
    {
      url: `${MATCH_H5}#/match/home?matchId=61360`,
      i18nKey: 'osten.subSelect.basketball_women'
    },
    {
      url: `${MATCH_H5}#/match/home?matchId=61228`,
      i18nKey: 'osten.subSelect.basketball_men'
    }
  ],
  football: [
    {
      url: `${MATCH_H5}#/match/home?matchId=61239`,
      i18nKey: 'osten.subSelect.football_women'
    },
    {
      url: `${MATCH_H5}#/match/home?matchId=61361`,
      i18nKey: 'osten.subSelect.football_men'
    }
  ]
}

export default {
  name: 'ActivityOstenSubSelect',
  data() {
    return {
      cdnLogo: `${OSTEN_CDN}/osten-icon.png`,
      sponsorUrls: Array.from({ length: 7 }, (_, i) => `${OSTEN_CDN}/osten-sponsor${i + 1}.png`),
      checked: this.$i18n.locale === 'en'
    }
  },
  computed: {
    sport() {
      return (this.$route.params.sport || '').toLowerCase()
    },
    linkRows() {
      return SUB_LINKS[this.sport] || []
    }
  },
  watch: {
    sport: {
      immediate: true,
      handler(s) {
        if (!SUB_LINKS[s]) {
          this.$router.replace('/activity-osten/home')
        }
      }
    }
  },
  mounted() {
    window.localStorage.setItem('activityOsten', 'activity-osten')
  },
  methods: {
    switchLanguage(value) {
      const language = value ? 'en' : 'zh'
      this.$i18n.locale = language
      localStorage.setItem('language', language)
    },
    openMatch(url) {
      if (url) window.location.href = url
    }
  }
}
</script>

<style scoped lang="scss">
.activity-osten-sub {
  min-height: 100vh;
  box-sizing: border-box;
  background: #ffffff;
  color: #3d3d3d;
  position: relative;
}

.activity-osten-main {
  box-sizing: border-box;
  padding: 16px 14px 0;
  padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
}

.header {
  display: flex;
  gap: 12px;
}

.header__logo-wrap {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
}

.header__logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.header__titles {
  flex: 1;
  min-width: 0;
  padding-top: 12px;
}

.header__line1 {
  font-size: 16px;
  font-weight: 500;
  color: #3d3d3d;
  letter-spacing: 0.02em;
  line-height: 1.25;
}

.header__line2 {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #3d3d3d;
  letter-spacing: 0.02em;
  line-height: 1.25;
}

.switch {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 14px;
  font-size: 18px;
  font-weight: 500;
  color: #1f57a7;
}

.sub-btns {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sub-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  padding: 0 16px;
  border: 2px solid #1f57a7;
  border-radius: 12px;
  background: #ffffff;
  box-sizing: border-box;
  color: #1f57a7;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.sub-btn:active {
  opacity: 0.85;
}

.partners {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  z-index: 10;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  box-sizing: border-box;
}

.partners__grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px 8px;
}

.partners__item {
  width: 80px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.partners__logo {
  height: 45px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

:deep(.van-switch__node) {
  background-color: #ffffff;
}
</style>
